import { render, staticRenderFns } from "./backups.vue?vue&type=template&id=db784d52&scoped=true"
import script from "./backups.vue?vue&type=script&lang=js"
export * from "./backups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db784d52",
  null
  
)

export default component.exports